export const NUMERIC = 'numeric';